module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/psg_two-17aaab268b9a97c879efaac5571f7998.png";